var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 44,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7333 43.4667C10.8222 43.4667 7.46667 42.0889 4.66667 39.3333C1.91111 36.5778 0.533334 33.2222 0.533334 29.2667C0.533334 25.8 1.64444 22.7556 3.86667 20.1333C6.13333 17.4667 8.97778 15.8667 12.4 15.3333C13.2889 10.9778 15.3778 7.44444 18.6667 4.73333C22 1.97778 25.8222 0.599998 30.1333 0.599998C35.1111 0.599998 39.3111 2.42222 42.7333 6.06667C46.2 9.66666 47.9333 14.0222 47.9333 19.1333V20.7333C51.1778 20.6444 53.9111 21.6889 56.1333 23.8667C58.3556 26.0444 59.4667 28.7778 59.4667 32.0667C59.4667 35.1778 58.3333 37.8667 56.0667 40.1333C53.8444 42.3556 51.1778 43.4667 48.0667 43.4667H32V22.2667L36.2 26.4667C36.6 26.8667 37.0667 27.0667 37.6 27.0667C38.1333 27.0667 38.6 26.8667 39 26.4667C39.4 26.0667 39.6 25.5778 39.6 25C39.6 24.4222 39.4 23.9333 39 23.5333L31.4667 15.9333C31.0667 15.5333 30.5778 15.3333 30 15.3333C29.4222 15.3333 28.9333 15.5333 28.5333 15.9333L20.9333 23.5333C20.5333 23.9333 20.3333 24.4222 20.3333 25C20.3778 25.5333 20.6 26 21 26.4C21.4 26.8 21.8667 27 22.4 27C22.9778 27 23.4889 26.8 23.9333 26.4L28 22.2667V43.4667H14.7333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-cloud.6b0dc0a4a07778eba1b9553c28aacd48.svg";